import { render, staticRenderFns } from "./add-remark.vue?vue&type=template&id=fa419fc0"
import script from "./add-remark.vue?vue&type=script&lang=ts"
export * from "./add-remark.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports